import { Suspense, useEffect } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useLocalStorage } from 'usehooks-ts';

import * as routes from 'router/routes';
import { LOGIN_QUERY_KEY } from 'constants/auth';
import { LOCAL_STORAGE_KEY, STRING_STORAGE_VALUE_OPTIONS } from 'constants/localStorage';
import { useQuery } from 'hooks/useQuery';
import { useChildRouteId } from 'hooks/useChildRouteId';
import { FullScreenLoader } from 'layouts';

const PrivateRoute = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const query = useQuery();
  const childRouteId = useChildRouteId();

  const token = query.get(LOGIN_QUERY_KEY.ACCESS);
  const refresh = query.get(LOGIN_QUERY_KEY.REFRESH);
  const isLoginRedirect = !!location.state?.isLoginRedirect;

  const [authToken, setAuthToken] = useLocalStorage(LOCAL_STORAGE_KEY.AUTH_TOKEN, null, STRING_STORAGE_VALUE_OPTIONS);
  const [, setRefreshToken] = useLocalStorage(LOCAL_STORAGE_KEY.REFRESH_TOKEN, null, STRING_STORAGE_VALUE_OPTIONS);
  const [, , removeFromLocation] = useLocalStorage(LOCAL_STORAGE_KEY.FROM_LOCATION, null);

  useEffect(() => {
    if (isLoginRedirect) {
      removeFromLocation();
      navigate(`${location.pathname}${location.search}${location.hash}`, { replace: true });
    }
  }, [isLoginRedirect, location.hash, location.pathname, location.search, navigate, removeFromLocation]);

  useEffect(() => {
    if (token && refresh) {
      setAuthToken(token);
      setRefreshToken(refresh);
    }
  }, [refresh, setAuthToken, setRefreshToken, token]);

  if (!authToken) {
    return <Navigate replace to={routes.loginScreen} state={{ from: location }} />;
  }

  return (
    <Suspense key={childRouteId} fallback={<FullScreenLoader />}>
      <Outlet />
    </Suspense>
  );
};

export default PrivateRoute;
